import {  useState,createContext } from 'react';
import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Radio, RadioGroup, FormHelperText, FormControlLabel } from '@mui/material';
// ----------------------------------------------------------------------


const RHFRadioButtonGroup = ({ name, options, getOptionLabel, ...other }) => {
  const { control } = useFormContext();
  const changeGender = (e) =>{
  }
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error }}) => (
        <div>
            <RadioGroup {...field} row {...other}>
              {options.map((option, index) => (
                <>
                <FormControlLabel
                  onChange={changeGender}
                  key={option.value}
                  value={option.value}
                  control={<Radio />}
                  label={getOptionLabel?.length ? getOptionLabel[index] : option.type}
                />
                {console.log(option,'option67565')}
                </>
              ))}
            </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
RHFRadioButtonGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  getOptionLabel: PropTypes.arrayOf(PropTypes.string),
};

export default RHFRadioButtonGroup;